import React, { useState, useEffect } from 'react';
import ProfilePage from './ProfilePage';
import { fetchUserProfile, updatePhoneNumber } from '../../services/user/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProfileContainer = () => {
  const [profileData, setProfileData] = useState({
    username: '',
    personalemail: '',
    phonenumber: '',
    companyname: '',
  });

  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const response = await fetchUserProfile();
        const data = response.data;

        setProfileData({
          username: data.username || '',
          personalemail: data.personalemail || '',
          phonenumber: data.phonenumber || '',
          companyname: data.companyname || '',
        });
      } catch (err) {
        setError('Failed to load profile');
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancelEdit = () => setIsEditingProfile(false);

  // ✅ FIXED: accept phone number directly
  const handleSaveProfile = async (newPhoneNumber) => {
    try {
      const response = await updatePhoneNumber(
        newPhoneNumber,
        profileData.personalemail
      );

      if (response.data.status) {
        setProfileData((prev) => ({
          ...prev,
          phonenumber: newPhoneNumber,
        }));

        toast.success('Phone number updated successfully.');
        setIsEditingProfile(false);
      } else {
        toast.error('Error updating phone number.');
      }
    } catch (error) {
      console.error('❌ Error updating phone number:', error);
      toast.error('Something went wrong while updating phone number.');
    }
  };

  if (loading)
    return (
      <div className="centered-message">
        <div className="spinner"></div>
        <div>Loading profile..</div>
      </div>
    );

  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <ProfilePage
        profileData={profileData}
        isEditingProfile={isEditingProfile}
        handleProfileChange={handleProfileChange}
        handleCancelEdit={handleCancelEdit}
        handleSaveProfile={handleSaveProfile}
      />
    </>
  );
};

export default ProfileContainer;
